
export default
{
    accessToken : 'pk.eyJ1IjoidGFsZXRlYW0iLCJhIjoiY2pja2F0dml5Mjg1bzJ5cnZjcnF0Mmd6ZCJ9.VHZnsERRNxoc0MNE7DEuhA' ,
    style       :'mapbox://styles/taleteam/cjckawctv9xo72rqifwf093ha'
};



// WEBPACK FOOTER //
// ./src/app/configs/views/map.js